import React, { useState } from 'react';

import GeneralRiskTypesTableEditRow from './GeneralRiskTypesTableEditRow';
import GeneralRiskTypesTableRow from './GeneralRiskTypesTableRow';

export default function GeneralRiskTypesTable(props) {
    const [editableType, setEditableType] = useState(null);

    const prepareUpdateUrl = (type) => {
        return props.updateUrl.replace('TYPE_ID', type.id);
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-w-44">{$t('Risk Type')}</th>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-40">{$t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!props.isLoading &&
                        !!props.types?.length &&
                        props.types.map((type) => {
                            if (editableType && parseInt(editableType.id) === parseInt(type.id)) {
                                return (
                                    <GeneralRiskTypesTableEditRow
                                        key={type.id}
                                        type={type}
                                        updateUrl={prepareUpdateUrl(type)}
                                        onUpdated={props.fetch}
                                        onCancel={() => setEditableType(null)}
                                    />
                                );
                            } else {
                                return (
                                    <GeneralRiskTypesTableRow
                                        key={type.id}
                                        type={type}
                                        onEdit={() => setEditableType(type)}
                                        onDelete={() => props.onDelete(type)}
                                    />
                                );
                            }
                        })}
                    {props.isLoading && (
                        <tr>
                            <td colSpan="100">{$t('Loading')}...</td>
                        </tr>
                    )}
                    {!props.isLoading && !props.types?.length && (
                        <tr>
                            <td colSpan="100">{$t('No Types found')}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
